export default __webpack_public_path__ + "fonts/mulish-v12-latin-700italic.woff2";